// Page "Informations utilisateur" (identité civile/office du notaire, utilisées par l'IA dans le
// texte des réponses générées).
import { bindActivate, describeActionError } from "../ui/domHelpers";
import { createDropdown, DropdownHandle } from "../ui/dropdown";
import { mailData } from "../mailData";
import { getSettings, saveSettings } from "../praetoria";

let userInfoFonctionDropdown: DropdownHandle;
let userInfoGenreDropdown: DropdownHandle;

// Appelé une fois au bootstrap (showAppBody), comme les autres dropdowns de l'app.
export function initUserInfoDropdowns(): void {
  userInfoFonctionDropdown = createDropdown("user-info-fonction-dropdown");
  userInfoGenreDropdown = createDropdown("user-info-genre-dropdown");
}

function hideUserInfoPage(): void {
  document.getElementById("user-info-page").style.display = "none";
  document.getElementById("app-body").style.display = "flex";
}

export async function showUserInfoPage(): Promise<void> {
  document.getElementById("app-body").style.display = "none";
  document.getElementById("user-info-page").style.display = "flex";
  document.getElementById("user-info-email").textContent = mailData.userEmail || "Inconnu";
  bindActivate("user-info-cancel", hideUserInfoPage);
  bindActivate("user-info-save", () => void handleSaveUserInfo());

  const statusElement = document.getElementById("user-info-status");
  statusElement.textContent = "";
  statusElement.className = "reply-status";

  if (!mailData.graphToken) {
    return;
  }
  try {
    const settings = await getSettings(mailData.graphToken);
    (document.getElementById("user-info-prenom") as HTMLInputElement).value = settings.prenom || "";
    (document.getElementById("user-info-nom") as HTMLInputElement).value = settings.nom || "";
    (document.getElementById("user-info-telephone") as HTMLInputElement).value = settings.telephone || "";
    userInfoFonctionDropdown.setValue(settings.fonction || "notaire");
    userInfoGenreDropdown.setValue(settings.genre || "homme");
    (document.getElementById("user-info-office") as HTMLTextAreaElement).value = settings.nom_office || "";
    (document.getElementById("user-info-adresse") as HTMLTextAreaElement).value = settings.adresse_cabinet || "";
  } catch (error) {
    statusElement.textContent = describeActionError("Impossible de charger les informations actuelles", error);
    statusElement.className = "reply-status reply-status--error";
  }
}

// Norme E.164 (ITU-T) : "+" suivi de l'indicatif pays et du numéro, 8 à 15 chiffres au total,
// sans zéro initial après l'indicatif. On tolère aussi la saisie sans indicatif (format national,
// ex: "01 23 45 67 89"), auquel cas on vérifie juste le nombre de chiffres après avoir retiré les
// séparateurs usuels (espaces, points, tirets, parenthèses).
const E164_PHONE_PATTERN = /^\+[1-9]\d{7,14}$/;
const NATIONAL_PHONE_PATTERN = /^\d{6,15}$/;

function isValidPhoneNumber(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) {
    return true;
  }
  const sanitized = trimmed.replace(/[\s().-]/g, "");
  return E164_PHONE_PATTERN.test(sanitized) || NATIONAL_PHONE_PATTERN.test(sanitized);
}

async function handleSaveUserInfo(): Promise<void> {
  const statusElement = document.getElementById("user-info-status");
  const saveButton = document.getElementById("user-info-save");
  const telephoneElement = document.getElementById("user-info-telephone") as HTMLInputElement;
  const adresseElement = document.getElementById("user-info-adresse") as HTMLTextAreaElement;

  if (!mailData.graphToken) {
    statusElement.textContent = "Session Microsoft expirée, rechargez le module.";
    statusElement.className = "reply-status reply-status--error";
    return;
  }

  if (!isValidPhoneNumber(telephoneElement.value)) {
    statusElement.textContent = "Le numéro de téléphone saisi n'est pas valide.";
    statusElement.className = "reply-status reply-status--error";
    telephoneElement.focus();
    return;
  }

  saveButton.classList.add("is-disabled");
  saveButton.setAttribute("aria-disabled", "true");
  statusElement.textContent = "";
  statusElement.className = "reply-status";

  try {
    await saveSettings(mailData.graphToken, {
      prenom: (document.getElementById("user-info-prenom") as HTMLInputElement).value,
      nom: (document.getElementById("user-info-nom") as HTMLInputElement).value,
      telephone: telephoneElement.value,
      fonction: userInfoFonctionDropdown.getValue(),
      genre: userInfoGenreDropdown.getValue(),
      nom_office: (document.getElementById("user-info-office") as HTMLTextAreaElement).value,
      adresse_cabinet: adresseElement.value,
    });
    statusElement.textContent = "Informations enregistrées.";
  } catch (error) {
    statusElement.textContent = describeActionError("Impossible d'enregistrer les informations", error);
    statusElement.className = "reply-status reply-status--error";
  } finally {
    saveButton.classList.remove("is-disabled");
    saveButton.removeAttribute("aria-disabled");
  }
}
